export enum BaseDataControl {
  EQUIPMENT_NAME = 'equipmentName',
  EQUIPMENT_CUSTOMER_SERIAL_NUMBER = 'equipmentCustomerSerialNumber',
  EQUIPMENT_COST_CENTER = 'equipmentCostCenter',
  ORGANISATION_NAME = 'organisationName',
  EQUIPMENT_MANUFACTURER = 'equipmentManufacturer',
  EQUIPMENT_MODEL = 'equipmentModel',
  EQUIPMENT_LICENSE_PLATE = 'equipmentLicensePlate',
  EQUIPMENT_CLASS = 'equipmentClass',
  EQUIPMENT_BGL_CODE = 'equipmentBGLCode',
  EQUIPMENT_CONSTRUCTION_YEAR = 'equipmentConstructionYear',
  EQUIPMENT_DELIVERY_DATE = 'equipmentDeliveryDate',
  EQUIPMENT_TYPE = 'equipmentType',
  OPERATING_HOURS = 'operatingHours',
  OPERATING_HOURS_LIMIT = 'operatingHoursLimit',
  CURRENT_MILEAGE = 'currentMileage',
  CURRENT_ADDRESS = 'currentAddress',
  PROJECT_COST_CENTER = 'projectCostCenter',
  EQUIPMENT_SERIAL_NUMBER = 'equipmentSerialNumber',
}
